import { hazmat_placarding_status } from '@/@types/generated'
import { register } from './enum'

const HazmatPlacardingStatusLabels: Record<hazmat_placarding_status, string> = {
  [hazmat_placarding_status.PLACARDED]: 'Placarded',
  [hazmat_placarding_status.CONDITIONAL]: 'Conditional',
  [hazmat_placarding_status.NON_PLACARDED]: 'Non-Placarded',
}

register<hazmat_placarding_status>(hazmat_placarding_status, (v) => {
  if (!v) return '—'
  return HazmatPlacardingStatusLabels[v]
})
